/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Media,
  ControlLabel,
  FormControl,
  FormGroup,
  Label,
  Clearfix,
} from "react-bootstrap";
import Select from "react-select";

import Card from "components/Card/Card.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import Button from "components/CustomButton/CustomButton.jsx";
import {
  importOrder,
  getCity,
  downloadLeadSample,
  GetAllSuppliers,
} from "../../../Listfunction";
import axios from "axios";
import ScreenLoader from "views/Components/screenLoader";
import { getApiErrorMessage } from "utils/getApiErrorMessage";

class adduser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectSupplier: "",
      supplierDetails: [],
      email: "",
      password: "",
      cfpassword: "",
      process: false,
      errors: [],
      useraccess: "",
      errormessage: "",
      btnDisabled: true,
      btnText: "Submit",
      profile_data: "",
      processing: true,
      errormessages: [],
      profile: "",
      message: "",
      selectedFile: [],
      country_detail: [],
      city_info: [],
      supplierError: null,
      attachmentError: null,
      isLoading: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.onDownload = this.onDownload.bind(this);
  }
  onDownload = (e) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    alert("on downlaod butto clicked");
    const link = document.createElement("a");
    link.href =
      "https://flash-prod.s3.ap-south-1.amazonaws.com/bulk-medication-template/SampleDoc.csv";
    link.target = "_blank";
    // document.body.appendChild(link)
    link.click();
  };
  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    // const {value } = e.target.type === 'select' ? e.target.selected : e.target.value;
    // console.log(list[index]['country'])

    if (value != "0") {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      var country_id = value;
      getCity(obj, country_id).then((res) => {
        this.setState({ city_info: res.data });
      });
    } else if (value == "0") {
      this.setState({ city_info: [] });
    }
    this.setState({
      [name]: value,
    });
  };

  async selectSuppliers() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    await GetAllSuppliers(obj).then((res) => {
      const suppliers = res.data.data.map((supplier) => ({
        value: supplier.id,
        label: supplier.name,
      }));
      this.setState({ supplierDetails: suppliers });
    });
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700,
    );
    var token = JSON.parse(localStorage.getItem("user"));
    if (token.role != 1 && token.role != 2) {
      this.props.history.push("/dashboard");
    }
    console.log(token, "user");
    this.setState({
      useraccess: token.role,
    });
    const obj = token.token;
    this.selectSuppliers();
  }

  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Invalid CSV format</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  async handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>{this.state.message}</b> .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  async onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;
    if (!this.state.selectSupplier || this.state.selectSupplier == "") {
      error = true;
      this.setState({
        supplierError: (
          <small className="text-danger">Supplier is required.</small>
        ),
        btnDisabled: true,
      });
    }
    if (this.state.profile.length === 0) {
      error = true;
      this.setState({
        attachmentError: (
          <small className="text-danger">Attachment is required.</small>
        ),
        btnDisabled: true,
      });
    }

    // this.setState({btnDisabled:true})
    // this.setState({btnText:"Processing"})
    if (!error) {
      this.setState({ isLoading: true });
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      // if(this.state.profile.length != 0 )
      // {
      this.setState({ processing: true });

      const fdata = new FormData();
      fdata.append("csv_file", this.state.profile);

      //          this.setState({ processing:false }, async() => {
      let url = `${process.env.REACT_APP_NOT_SECRET_CODE}/medications/bulk/import/csv?supplier_id=${this.state.selectSupplier.value ? this.state.selectSupplier.value : ""}`;
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          console.log("res.data.success", res.status);
          this.setState({ message: res.data.message });
          console.log(res, "result");
          if (res.data.success) {
            this.handleSuccess("bl");
          }
          this.setState({ message: res.data.message });
          this.setState({ btnText: "Submit" });
          this.setState({
            btnDisabled: false,
            profile: "",
            selectSupplier: "",
          });
        })
        .catch((err) => {
          console.log("!!!!!", err);
          this.handleClick("bl");
        });

      // }
      // else{
      //     alert("Please upload Excel file")
      // }
    }
    this.setState({ isLoading: false });
  }
  handleNetworkError(position, error) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {/* <b>Network Error</b>. */}
          <b>{getApiErrorMessage(error)}</b>
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  handleFileChange(event) {
    //console.log(event.target.files[0] ,"file object");
    this.setState({ profile: event.target.files[0], btnDisabled: false });
  }

  upload() {
    document.getElementById("selectImage").click();
  }

  handleChange = (selectedOption) => {
    this.setState({ selectSupplier: selectedOption, supplierError: null });
  };
  render() {
    const errormessage = this.state.errormessage;
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" />
          <Row style={{ height: "70vh" }}>
            <Col md={6}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <ControlLabel> Select Supplier</ControlLabel>
                          <Select
                            name="selectSupplier"
                            value={this.state.selectSupplier}
                            onChange={this.handleChange}
                            options={this.state.supplierDetails}
                            placeholder="Select Supplier"
                          />
                          {this.state.supplierError}
                        </FormGroup>
                        <br />
                        <br />
                        <FormGroup>
                          <ControlLabel>Medication Excel</ControlLabel>
                          <br></br>
                          <input
                            style={{ display: "none" }}
                            id="selectImage"
                            type="file"
                            className="form-control"
                            name="profile"
                            onChange={this.handleFileChange}
                          />
                          <Button
                            onClick={this.upload}
                            style={{ color: "#2B3A41" }}
                          >
                            {" "}
                            <i
                              className={
                                this.state.profile == ""
                                  ? "fa fa-plus"
                                  : "fa fa-pencil fa-fw"
                              }
                            ></i>{" "}
                            {this.state.profile == ""
                              ? "Choose Excel"
                              : "Change Excel"}
                          </Button>
                        </FormGroup>
                        <div>
                          {/* {this.state.message != "" && <h6 style={{color:"red"}}>{this.state.message}</h6>}
                    <br/> */}

                          {this.state.errors.length != 0 && (
                            <React.Fragment>
                              <h5>Errors</h5>
                              <ul>
                                {this.state.errors.map((index) => {
                                  return <li>{index}</li>;
                                })}
                              </ul>
                            </React.Fragment>
                          )}
                        </div>
                        <div>
                          <br />
                          <Button
                            class="btn-color"
                            disabled={this.state.btnDisabled}
                            onClick={this.onSubmit.bind(this)}
                            fill
                          >
                            {this.state.btnText}
                          </Button>
                          &nbsp;&nbsp;
                          <Button
                            class="btn-color"
                            onClick={this.onDownload.bind(this)}
                            fill
                          >
                            Download Sample Excel
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.isLoading ? <ScreenLoader /> : ""}
      </div>
    );
  }
}

export default adduser;
